export const BlockQuote = 'blockquote';
//# sourceMappingURL=blockquote.js.map